<eff-expansion-panel
    [contentTemplate]="content"
    [panelOpenState]="panelOpenState"
    [title]="'effTestInstructions.panelTitle' | t"
    class="eff-details-panel"
>
    <ng-template #content>
        <div class="rows-container">
            @if (effectivenessModel.testInstructions) {
                <div>
                    <div
                        class="regular-text multiple-whitespaces"
                        [innerHTML]="effectivenessModel.testInstructions"
                    ></div>
                </div>
            }
            @if (
                samples &&
                samples.length > 0 &&
                samples[0].testSteps &&
                samples[0].testSteps.length > 0
            ) {
                <div class="steps-container">
                    @for (testStep of samples[0].testSteps; track testStep) {
                        <eff-expansion-panel
                            class="test-step-panel"
                            [panelOpenState]="true"
                            [contentTemplate]="stepContent"
                            [title]="'Step ' + testStep.name"
                            data-uiid="new-eff-upload-source-document-test-instructions-info-box"
                        >
                            <ng-template #stepContent>
                                <div class="step-rows">
                                    <div class="step-row">
                                        <div class="bold-text-small">{{ 'effTestInstructions.testMethod' | t }}</div>
                                        <div class="regular-text-small">
                                            {{ testStep.testMethod }}
                                        </div>
                                    </div>
                                    <div class="step-row">
                                        <div class="bold-text-small">{{ 'effTestInstructions.description' | t }}</div>
                                        <div
                                            class="regular-text-small multiple-whitespaces"
                                            [innerHTML]="testStep.description"
                                        ></div>
                                    </div>
                                    <div class="step-row">
                                        <div class="bold-text-small">{{ 'effTestInstructions.requiredDocuments' | t }}</div>
                                        <div class="regular-text-small">
                                            {{
                                                testStep.requiredDocuments
                                                    ? testStep.requiredDocuments
                                                    : "-"
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </eff-expansion-panel>
                    }
                </div>
            }
            <div class="row-container">
                <div class="bold-text row-label">{{ 'effTestInstructions.linkedStandard' | t }}</div>
                <div
                    class="regular-text multiple-whitespaces"
                    [innerHTML]="effectivenessModel.linkedStandard"
                ></div>
            </div>
            <div class="row-container">
                <div class="bold-text row-label">{{ 'effTestInstructions.qualityAspects' | t }}</div>
                <div
                    class="regular-text multiple-whitespaces"
                    [innerHTML]="effectivenessModel.qualityAspects"
                ></div>
            </div>
            <div class="row-container">
                <div class="bold-text row-label">{{ 'effTestInstructions.testNorm' | t }}</div>
                <div
                    class="regular-text multiple-whitespaces"
                    [innerHTML]="effectivenessModel.testNorm"
                ></div>
            </div>

            @if (showEvidenceUploadInstructions && effectivenessModel.evidenceUploadInstructions) {
                <div class="bold-text row-label">{{ 'effTestInstructions.evidenceUploadInstructions' | t }}</div>
                <div class="regular-text">
                    <div
                        class="regular-text multiple-whitespaces"
                        [innerHTML]="effectivenessModel.evidenceUploadInstructions"
                    ></div>
                </div>
            }
        </div>
    </ng-template>
</eff-expansion-panel>
